import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import HseModal from './HseModal.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = HseModal;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HseModalPortal',[_c('HseBaseModal',{attrs:{"modal-style":_vm.modalStyle,"modal-class":_vm.modalClassComputed,"open":_vm.open,"shouldCloseOnOverlayClick":_vm.shouldCloseOnOverlayClick,"shouldCloseOnEsc":_vm.shouldCloseOnEsc},on:{"toggle":function($event){return _vm.$emit('toggle', $event)}}},[_vm._t("default")],2)],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
